// extracted by mini-css-extract-plugin
export default {"submenu":"submenu_submenu__HsBuL","submenu_item":"submenu_submenu_item__nCA9i","submenu_link":"submenu_submenu_link__8QLin","submenu_title":"submenu_submenu_title__LbSiw"};